import { _Locale } from "./supportedLocale";

export type FormatPercentageArgs = {
  value: unknown;
  locale?: _Locale;
  multiplier?: number;
  zeroAligned?: boolean;
  numDecimals: number;
};

/**
 * Format number between 0 and 1 to percentage locale string.
 */
export const formatPercentage = ({
  value,
  locale = "en-US",
  numDecimals,
  multiplier = 1,
  zeroAligned = false,
}: FormatPercentageArgs) => {
  const num = Number(value);
  if (isNaN(num)) return "";

  const options: Intl.NumberFormatOptions = {
    style: "percent",
    minimumFractionDigits: numDecimals,
    maximumFractionDigits: numDecimals,
  };

  if (zeroAligned) {
    options.minimumFractionDigits = numDecimals;
  }

  return (num * multiplier).toLocaleString(locale, options);
};
